// Angular Imports
import {
	ChangeDetectionStrategy,
	Component,
	Input,
	booleanAttribute,
	computed,
	inject,
} from '@angular/core'
import { NgTemplateOutlet } from '@angular/common'
// Angular Material Imports
import { MatMenuModule } from '@angular/material/menu'
import { MatRippleModule } from '@angular/material/core'
// Shared Imports
import { FlagCountryComponent } from '../flag-country/flag-country.component'
import { ECountry, COUNTRIES, EEnvironment, ERoles } from '@shared/models'
import { AuthStore } from '@shared/store'
// Store Imports

@Component({
	standalone: true,
	imports: [NgTemplateOutlet, MatMenuModule, MatRippleModule, FlagCountryComponent],
	selector: 'app-flag-country-button',
	templateUrl: './flag-country-button.component.html',
	styleUrl: './flag-country-button.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlagCountryButtonComponent {
	readonly #authStore = inject(AuthStore)
	readonly EEnvironment = EEnvironment

	@Input({ transform: booleanAttribute }) isFull: boolean = false

	country = computed(() => this.#authStore.country())
	countries: ECountry[] = COUNTRIES
	environment: EEnvironment = EEnvironment.dev

	isAdministrator = computed(() => this.#authStore.roles().includes(ERoles.administrator))

	constructor() {}

	onSelectCountry(country: ECountry) {
		this.#authStore.updateCountry({ country })
		window.location.reload()
	}
}
